import { forwardRef, useEffect, useRef, useState } from 'react';

import Alert from 'react-bootstrap/Alert';
import PropTypes from 'prop-types';
import styles from './AlertWrapper.scss';

const AlertWrapper = forwardRef(
  ({ children, hideIcon = false, show = true, autoCloseTime, onClose, className, ...rest }, ref) => {
    const { variant } = rest;
    const [visible, setVisible] = useState(show);
    const timerRef = useRef(null);

    const iconNames = {
      danger: 'error_outline',
      info: 'info',
      success: 'check_circle_outline_success',
      warning: 'warning_amber',
    };
    useEffect(() => {
      if (show !== undefined) {
        setVisible(show);
      }
    }, [show]);

    const cancelTimer = (ref) => {
      if (ref.current) {
        clearTimeout(ref.current);
        ref.current = null;
      }
    };
    useEffect(() => {
      cancelTimer(timerRef);
      if (autoCloseTime && autoCloseTime > 0 && visible) {
        timerRef.current = setTimeout(() => {
          setVisible(false);
          if (onClose) onClose();
        }, autoCloseTime);
      }
      return () => {
        cancelTimer(timerRef);
      };
    }, [autoCloseTime, visible, onClose]);

    const handleManualClose = (...args) => {
      setVisible(false);
      if (onClose) onClose(...args);
    };
    return (
      <Alert
        {...rest}
        show={visible}
        onClose={handleManualClose}
        className={`${styles['alert-wrapper']} ${styles[variant] || ''} ${className || ''}`}
        ref={ref}
        style={{
          '--alert-wrapper-btn-close-bg': `url('/resources/assets/ui/nextgen/${variant || ''}_clear.svg')`,
          '--alert-wrapper-icon-bg': `url('/resources/assets/ui/nextgen/${iconNames[variant] || ''}.svg')`,
        }}>
        {!hideIcon && <div className={styles['alert-icon']} />}
        <div className={styles['alert-content']}>{children}</div>
      </Alert>
    );
  }
);

AlertWrapper.propTypes = {
  hideIcon: PropTypes.bool,
};

export default AlertWrapper;
